(function(){
"use strict";

var ST_ITEMS = [];
var stIdx = 0, stRAF = null, stTimerEnd = 0, stCurrentSectionId = null, stLastFocused = null;
// Single source of truth for the mute preference, applied to whichever
// element (video or iframe) is active for the current item — without this,
// the mute icon and the actual audio state drift apart as items change.
var stMuted = true;

var EMBED = {
  youtube: function(url){
    var m = url.match(/(?:shorts\/|watch\?v=|youtu\.be\/|embed\/)([\w-]{11})/);
    if(!m) return null;
    var id = m[1];
    // no loop/playlist param — our own duration timer advances to the next
    // short, and setting playlist (needed for YouTube's single-video loop
    // workaround) makes YouTube treat this as a playlist, which is what
    // triggers its native prev/next/play controls we don't want visible.
    var p = new URLSearchParams({autoplay:"1",mute:"1",playsinline:"1",controls:"0",rel:"0",modestbranding:"1",enablejsapi:"1",origin:location.origin});
    return "https://www.youtube-nocookie.com/embed/" + id + "?" + p;
  },
  vimeo: function(url){
    var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? "https://player.vimeo.com/video/" + m[1] + "?autoplay=1&muted=1&byline=0&title=0&controls=0" : null;
  },
  tiktok: function(url){
    var m = url.match(/\/video\/(\d{6,25})/);
    return m ? "https://www.tiktok.com/embed/v2/" + m[1] : null;
  },
  instagram: function(url){
    var m = url.match(/instagram\.com\/(?:reel|reels|p|tv)\/([\w-]+)/);
    return m ? "https://www.instagram.com/reel/" + m[1] + "/embed/captioned/" : null;
  }
};

// providers whose playhead/ended events we can't read — driven by duration_seconds timer instead
var GATED_PROVIDERS = { tiktok: true, instagram: true };
var TIMED_PROVIDERS = { tiktok: true, instagram: true };

var DETECT = [
  ["youtube", /(?:youtube\.com|youtu\.be)/],
  ["vimeo", /vimeo\.com/],
  ["tiktok", /tiktok\.com/],
  ["instagram", /instagram\.com/]
];

// merchants only fill video_file (upload) or video_url (external link) —
// the provider itself is inferred, never asked for
function detectProvider(item){
  if(item.sources && item.sources.length) return "uploaded";
  if(!item.url) return null;
  for(var i = 0; i < DETECT.length; i++){
    if(DETECT[i][1].test(item.url)) return DETECT[i][0];
  }
  return null;
}

function reducedMotion(){
  return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function els(){
  return {
    overlay: document.getElementById("stories-overlay"),
    video: document.getElementById("st-video"),
    frame: document.getElementById("st-frame"),
    gate: document.getElementById("st-gate"),
    cap: document.getElementById("st-cap"),
    bars: document.getElementById("st-bars"),
    mute: document.getElementById("st-mute"),
    fimg: document.getElementById("st-fimg"),
    fname: document.getElementById("st-fname"),
    fprice: document.getElementById("st-fprice"),
    atc: document.getElementById("st-atc"),
    buy: document.getElementById("st-buy")
  };
}

function getItems(sectionId){
  var script = document.getElementById("shorts-data-" + sectionId);
  if(!script) return [];
  try{ return JSON.parse(script.textContent) || []; }
  catch(e){ return []; }
}

function stBuildBars(){
  var e = els();
  e.bars.innerHTML = ST_ITEMS.map(function(){ return '<div class="st-bar"><i></i></div>'; }).join("");
}

window.openStories = function(sectionId){
  var e = els();
  if(!e.overlay) return;
  stCurrentSectionId = sectionId || stCurrentSectionId;
  ST_ITEMS = getItems(stCurrentSectionId);
  if(!ST_ITEMS.length) return;
  e.overlay.classList.add("open");
  e.overlay.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";
  stBuildBars();
  stLastFocused = document.activeElement;
  e.overlay.querySelector(".st-close").focus();
  stPlay(0);
};

window.closeStories = function(){
  var e = els();
  if(!e.overlay) return;
  e.overlay.classList.remove("open");
  e.overlay.setAttribute("aria-hidden", "true");
  document.body.style.overflow = "";
  stTeardownCurrent();
  if(stRAF) cancelAnimationFrame(stRAF);
  if(stLastFocused && stLastFocused.focus) stLastFocused.focus();
};

function stUpdateMuteIcon(){
  var e = els();
  if(e.mute) e.mute.innerHTML = stMuted ? "&#128263;" : "&#128266;";
}

function stTeardownCurrent(){
  var e = els();
  if(e.video){ e.video.pause(); e.video.removeAttribute("src"); e.video.load(); e.video.style.display = "none"; }
  if(e.frame){ e.frame.src = ""; e.frame.style.display = "none"; }
  if(e.gate){ e.gate.style.display = "none"; }
  clearTimeout(stTimerEnd);
}

function stPlay(i){
  var e = els();
  if(i < 0) i = 0;
  if(i >= ST_ITEMS.length){ closeStories(); return; }
  stTeardownCurrent();
  stIdx = i;
  var item = ST_ITEMS[i];
  e.cap.innerHTML = item.title || item.caption || "";
  e.fimg.src = item.product.image || "";
  e.fname.textContent = item.product.title || "";
  e.fprice.innerHTML = item.product.price || "";
  if(e.buy) e.buy.dataset.url = item.product.url || "";

  var bars = document.querySelectorAll("#st-bars .st-bar");
  bars.forEach(function(b, bi){
    var f = b.querySelector("i");
    f.style.width = (bi < i ? "100%" : "0");
  });

  var provider = detectProvider(item);

  if(provider === "uploaded"){
    e.video.style.display = "";
    if(item.sources && item.sources.length){
      e.video.innerHTML = item.sources.map(function(s){ return '<source src="' + s.url + '" type="' + s.type + '">'; }).join("");
      e.video.load();
    }
    // .load() can reset the element's muted state to its HTML attribute
    // default in some browsers — always reapply the user's actual
    // preference explicitly rather than relying on it persisting.
    e.video.muted = stMuted;
    stUpdateMuteIcon();
    try{ e.video.currentTime = 0; }catch(err){}
    e.video.play().catch(function(){});
    e.video.onended = function(){ if(!reducedMotion()) stPlay(i + 1); };
    stTrackPlayhead(bars, i, function(){ return e.video.currentTime / (e.video.duration || item.duration || 15); });
  } else if((provider === "youtube" || provider === "vimeo") && item.url){
    e.frame.style.display = "";
    var src = EMBED[provider] ? EMBED[provider](item.url) : null;
    e.frame.src = src || "";
    stUpdateMuteIcon();
    // Autoplay only works muted, so the embed URL always starts muted
    // regardless of preference — if the shopper had already unmuted,
    // send the unmute command once the new player's had a moment to load.
    if(!stMuted){
      var frameRef = e.frame, unmuteProvider = provider;
      setTimeout(function(){
        if(frameRef.contentWindow){
          var message = unmuteProvider === "youtube"
            ? { event: "command", func: "unMute", args: [] }
            : { method: "setVolume", value: 1 };
          frameRef.contentWindow.postMessage(JSON.stringify(message), "*");
        }
      }, 400);
    }
    if(!reducedMotion()){
      stTimerEnd = setTimeout(function(){ stPlay(i + 1); }, (item.duration || 15) * 1000);
    }
    stTrackTimer(bars, i, item.duration || 15);
  } else if(GATED_PROVIDERS[provider]){
    stShowPosterGate(item, i);
  } else {
    // no playable source — skip to next
    stPlay(i + 1);
  }

  trackShortEvent("short_open", item);
}

function stShowPosterGate(item, i){
  var e = els();
  var provider = detectProvider(item);
  e.gate.style.display = "flex";
  e.gate.style.backgroundImage = "url('" + item.poster + "')";
  e.gate.onclick = function(){
    e.gate.style.display = "none";
    e.frame.style.display = "";
    var src = EMBED[provider] ? EMBED[provider](item.url) : null;
    if(!src){ stFallbackToPoster(item); return; }
    e.frame.src = src;
    e.frame.onerror = function(){ stFallbackToPoster(item); };
    var bars = document.querySelectorAll("#st-bars .st-bar");
    if(TIMED_PROVIDERS[provider]){
      if(!reducedMotion()){
        stTimerEnd = setTimeout(function(){ stPlay(i + 1); }, (item.duration || 15) * 1000);
      }
      stTrackTimer(bars, i, item.duration || 15);
    }
  };
}

function stFallbackToPoster(item){
  var e = els();
  e.frame.style.display = "none";
  e.gate.style.display = "flex";
  e.gate.onclick = function(){ window.open(item.url, "_blank", "noopener"); };
}

function stTrackPlayhead(bars, i, getProgress){
  if(stRAF) cancelAnimationFrame(stRAF);
  function tick(){
    var p = Math.min(1, getProgress() || 0);
    var f = bars[i] ? bars[i].querySelector("i") : null;
    if(f) f.style.width = (p * 100) + "%";
    if(document.getElementById("stories-overlay").classList.contains("open")){
      stRAF = requestAnimationFrame(tick);
    }
  }
  stRAF = requestAnimationFrame(tick);
}

function stTrackTimer(bars, i, duration){
  if(stRAF) cancelAnimationFrame(stRAF);
  var start = performance.now();
  function tick(){
    var p = Math.min(1, (performance.now() - start) / (duration * 1000));
    var f = bars[i] ? bars[i].querySelector("i") : null;
    if(f) f.style.width = (p * 100) + "%";
    if(p < 1 && document.getElementById("stories-overlay").classList.contains("open")){
      stRAF = requestAnimationFrame(tick);
    }
  }
  stRAF = requestAnimationFrame(tick);
}

// namespace all IDs and ID-referring attributes in a subtree so that
function stNamespaceIds(root, suffix){
  var idRefAttrs = ["for", "aria-controls", "aria-describedby", "aria-labelledby", "aria-owns", "list", "form", "variant-selection"];
  var idMap = {};
  root.querySelectorAll("[id]").forEach(function(el){
    var oldId = el.id;
    var newId = oldId + suffix;
    idMap[oldId] = newId;
    el.id = newId;
  });
  root.querySelectorAll(idRefAttrs.map(function(a){ return "[" + a + "]"; }).join(",")).forEach(function(el){
    idRefAttrs.forEach(function(attr){
      var val = el.getAttribute(attr);
      if(val && idMap[val]) el.setAttribute(attr, idMap[val]);
    });
  });
}

function stOpenQuickshop(item, triggerBtn){
  if(!window.modal || typeof window.modal.open !== "function"){
    return stDirectAddToCart(item, triggerBtn);
  }
  var video = document.getElementById("st-video");
  if(video) video.pause();
  if(stRAF) cancelAnimationFrame(stRAF);
  clearTimeout(stTimerEnd);


  var modalRoot = document.querySelector(".modal");
  if(modalRoot && modalRoot.parentElement !== document.body){
    document.body.appendChild(modalRoot);
  }

  window.modal.open({ trigger: triggerBtn, classname: "modal--quickshop" });

  var url = item.product.url + (item.product.url.indexOf("?") > -1 ? "&" : "?") + "view=quickshop";

  var pageVariantSelection = document.querySelector('variant-selection[product-url="' + item.product.url + '.js"]');
  var pageVariant = pageVariantSelection ? pageVariantSelection.getAttribute("variant") : null;
  if(pageVariant) url += "&variant=" + pageVariant;
  fetch(url).then(function(res){ return res.text(); }).then(function(html){
    var doc = new DOMParser().parseFromString(html, "text/html");
    var content = doc.querySelector("[data-quickshop]");
    var modalContent = document.querySelector("[data-modal-content]");
    if(!content || !modalContent){ window.modal.close(); return stDirectAddToCart(item, triggerBtn); }

    content.querySelectorAll("noscript").forEach(function(el){ el.remove(); });
    stNamespaceIds(content, "-shortsqs");
    modalContent.innerHTML = "";
    modalContent.appendChild(content);
    var atcBtn = modalContent.querySelector("[data-product-atc]");
    if(atcBtn){
      atcBtn.addEventListener("click", function(e){
        if(atcBtn.closest(".product-form--error-option-unselected")) return;
        e.preventDefault();
        atcBtn.dispatchEvent(new Event("quickshop-add", { bubbles: true }));
        trackShortEvent("short_add_to_cart", item);
        window.modal.close();
      });
    }
  }).catch(function(){
    window.modal.close();
    stDirectAddToCart(item, triggerBtn);
  });
}

window.stNext = function(){ trackShortEvent("short_next", ST_ITEMS[stIdx]); stPlay(stIdx + 1); };
window.stPrev = function(){ trackShortEvent("short_prev", ST_ITEMS[stIdx]); stPlay(stIdx - 1); };

window.stToggleMute = function(){
  var e = els();
  var item = ST_ITEMS[stIdx];
  var provider = item ? detectProvider(item) : null;

  stMuted = !stMuted;
  stUpdateMuteIcon();

  if((provider === "youtube" || provider === "vimeo") && e.frame && e.frame.contentWindow){
    var message = provider === "youtube"
      ? { event: "command", func: stMuted ? "mute" : "unMute", args: [] }
      : { method: "setVolume", value: stMuted ? 0 : 1 };
    e.frame.contentWindow.postMessage(JSON.stringify(message), "*");
  } else if(e.video){
    e.video.muted = stMuted;
  }

  trackShortEvent("short_unmute", item);
};

function trackShortEvent(name, item){
  if(!item || !window.dataLayer) return;
  window.dataLayer.push({
    event: name,
    short_id: item.id,
    provider: detectProvider(item),
    position: stIdx,
    product_id: item.product && item.product.id
  });
}

function stRefreshCartCount(){
  fetch(window.Shopify.routes.root + "cart.js").then(function(res){ return res.json(); }).then(function(cart){
    var countEl = document.querySelector("[data-header-cart-count]");
    if(countEl) countEl.textContent = cart.item_count;
  });
}

function stDirectAddToCart(item, btn){
  btn.disabled = true;
  var body = new FormData();
  body.append("id", item.product.variantId);
  body.append("quantity", 1);
  body.append("properties[_short_id]", item.id);
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Accept": "application/json" },
    body: body
  }).then(function(res){ return res.json(); }).then(function(data){
    btn.disabled = false;
    if(data.status){ stToast(data.description || data.message); return; }
    stRefreshCartCount();
    stToast("Added to cart");
    trackShortEvent("short_add_to_cart", item);
  }).catch(function(){ btn.disabled = false; });
}

window.shortAddToCart = function(btn){
  var item = ST_ITEMS[stIdx];
  if(!item) return;
  if(item.product.needsPicker){ stOpenQuickshop(item, btn); return; }
  stDirectAddToCart(item, btn);
};

window.shortBuyNow = function(){
  var item = ST_ITEMS[stIdx];
  if(!item) return;
  var body = new FormData();
  body.append("id", item.product.variantId);
  body.append("quantity", 1);
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Accept": "application/json" },
    body: body
  }).then(function(){ window.location = window.Shopify.routes.root + "checkout"; });
};

function stToast(msg){
  var t = document.getElementById("qa-toast") || document.getElementById("st-toast");
  if(!t){
    t = document.createElement("div");
    t.id = "st-toast";
    t.className = "qa-toast";
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.add("show");
  clearTimeout(t._t);
  t._t = setTimeout(function(){ t.classList.remove("show"); }, 2200);
}

document.addEventListener("keydown", function(e){
  if(e.key === "Escape") closeStories();
});

document.addEventListener("click", function(e){
  var card = e.target.closest("[data-shorts-card]");
  if(card){
    openStories(card.getAttribute("data-section-id"));
    stPlay(parseInt(card.getAttribute("data-index"), 10) || 0);
  }
});

// muted preview when a rail card scrolls into view (uploaded videos only)
if("IntersectionObserver" in window){
  var previewIO = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      var video = entry.target.querySelector("video[data-preview]");
      if(!video) return;
      if(entry.isIntersecting && entry.intersectionRatio >= 0.6){
        if(!reducedMotion() && !(navigator.connection && navigator.connection.saveData)){
          video.play().catch(function(){});
        }
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.6 });
  document.addEventListener("DOMContentLoaded", function(){
    document.querySelectorAll("[data-shorts-card]").forEach(function(card){ previewIO.observe(card); });
  });
}
})();
